module.exports = __webpack_public_path__ + "img/saishianpai-icon-5.ca628369.png";